import { scope, vector } from '../instructions';
export var CURRENCIES = scope('Currencies', 'Currencies', [
    vector('displayName', ['currency-id']),
    vector('decimal', ['currency-id']),
    vector('pluralName', ['plural-key', 'currency-id']),
    vector('symbol', ['alt-key', 'currency-id']),
]);
//# sourceMappingURL=currencies.js.map